import cx from 'classnames';

import { Box, BoxProps } from '@/components/Elements';

import * as styles from './Heading.css';

const getHeadingComponent = (variant: HeadingProps['variant']) => {
  if (variant === 'h1') {
    return 'h1';
  }
  if (variant === 'h2') {
    return 'h2';
  }
  if (variant === 'h3') {
    return 'h3';
  }
  if (variant === 'subhead') {
    return 'h4';
  }

  return 'h2';
};

export interface HeadingProps extends BoxProps {
  variant: 'h1' | 'h2' | 'h3' | 'subhead';
}

export const Heading = ({ variant, component, className, ...props }: HeadingProps) => {
  return (
    <Box
      className={cx(styles[variant], className)}
      component={component || getHeadingComponent(variant)}
      {...props}
    />
  );
};
